/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useContext, useState } from "react";
import { DateTimeEdit } from "../_common/date-time";
import Config from "data/config";
import dayjs from "dayjs";
import { EntityContext } from "../../context";
// import debounce from "lodash.debounce";
// import { useTranslation } from "react-i18next";

const DateEntityAttributeEditor = (props) => {
    
    const type = props.type;
    const name = props.name;
    const value = props.value;

    const parseFormat = Config.dates.internalFormats.date;

    const [datetime, setDatetime] = useState(value);

    const entityContext = useContext(EntityContext);
    const updateAttribute = entityContext?.updateAttribute;

    const onChangeDateTime = (selectedDate) => {
        const selected = selectedDate
            ? dayjs(selectedDate).format(parseFormat)
            : "";
        setDatetime(selected);
        updateAttribute(name, selected);
    };
    
    return (
        <Fragment>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                <DateTimeEdit
                    name={name}
                    type={type}
                    value={datetime}
                    onChangeDateTime={onChangeDateTime}
                />
            </div>
        </Fragment>
    );
};

export { DateEntityAttributeEditor };
